module.exports = __webpack_public_path__ + "static/media/Ustav_Formoplast_16.02.2018.10abfeaf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Ustav_Formoplast_16.02.2018.pdf
// module id = 147
// module chunks = 0